import { createSlice } from '@reduxjs/toolkit';
import { fetchComplianceCentre } from './complianceCentreActions';

const complianceCentreSlice = createSlice({
  name: 'complianceCentre',
  initialState: { data: null, loading: false, error: null, requestId: null },
  reducers: {},
  extraReducers: builder => builder
    .addCase(fetchComplianceCentre.pending, (state, action) => {
      state.data = null;
      state.loading = true;
      state.error = null;
      state.requestId = action.meta.requestId;
    })
    .addCase(fetchComplianceCentre.fulfilled, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.data = action.payload;
      state.loading = false;
      state.requestId = null;
    })
    .addCase(fetchComplianceCentre.rejected, (state, action) => {
      if (state.requestId !== action.meta.requestId) return;
      state.loading = false;
      state.error = action.meta.aborted ? null : action.payload || 'Unable to load compliance centre';
      state.requestId = null;
    }),
});
export default complianceCentreSlice.reducer;
